/**
 * Formats a number of bytes into a human-readable string with appropriate units
 * Uses binary (1024-based) calculations which is standard for memory/storage
 * Examples:
 * 512 -> 512 B
 * 2048 -> 2 KB
 * 1572864 -> 1.5 MB
 * 1073741824 -> 1 GB
 *
 * @param {number} bytes - The number of bytes to format
 * @param {number} [precision=2] - Number of decimal places to show
 * @returns {string} - Formatted byte string with unit suffix
 */
export const formatBytes = (bytes, precision = 2) => {
  if (bytes === null || bytes === undefined || isNaN(Number(bytes))) {
    return '0 B';
  }

  const num = Number(bytes);

  if (num === 0) {
    return '0 B';
  }

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(Math.abs(num)) / Math.log(k));

  const sizeIndex = Math.min(i, sizes.length - 1);

  const value = num / Math.pow(k, sizeIndex);
  const formattedValue = sizeIndex === 0 ? value.toString() : value.toFixed(precision).replace(/\.?0+$/, '');

  return `${formattedValue} ${sizes[sizeIndex]}`;
};

export default formatBytes;
